<template>
  <LoaderWrapper ref="loader" class="h-100">
    <div class="row m-4 mt-0 mb-0">
    <div class="col-sm-12">
      <div class="card card-body mb-0">

        <div class="row">
          <div class="form-group me-2 col-md-3 col-lg-3 col-xl-2">
            <div class="col p-0">
              <div class="">
                <input type="number" min="1" class="form-control form-control-sm no-spinner" @keydown.enter="() => applyFilters()" :placeholder="helper.trans('labels.store_id')" v-model="storeId">
              </div>
            </div>
          </div>

          <div class="form-group me-2 col-md-3 col-lg-3 col-xl-2">
            <div class="col p-0">
              <div class="">
                <input type="text" class="form-control form-control-sm" @keydown.enter="() => applyFilters()" :placeholder="helper.trans('labels.name')" v-model="requestDTO.query">
              </div>
            </div>
          </div>

          <div class="form-group me-2 col-md-3 col-lg-3 col-xl-2">
            <div class="col p-0">
              <div class="">
                <Multiselect
                  class="multiselect-sm"
                  v-model="selectedTrafficGroups"
                  :options="trafficGroupsOptions"
                  :custom-label="(opt) => `${opt.name} - ${opt.type}`"
                  track-by="id"
                  select-label="Select"
                  :placeholder="helper.trans('labels.traffic_group')"
                  open-direction="bottom"
                  :multiple="true"
                  :searchable="true"
                  :internal-search="true"
                  :clear-on-select="false"
                  :close-on-select="false"
                  :options-limit="100"
                  :limit="1000"
                  :show-no-results="false"
                  :hide-selected="true"
                >
                </Multiselect>
              </div>
            </div>
          </div>

          <div class="form-group col">
            <div class="col-auto p-0 text-end ">
              <button type="button" @click.prevent="() => applyFilters()" class="btn btn-outline-primary btn-sm rounded-pill me-2 text-capitalize-first">{{ helper.trans('button.apply') }}</button>
              <button type="button" @click.prevent="() => clearFilters()" class="btn btn-outline-secondary btn-sm rounded-pill text-capitalize-first">{{ helper.trans('button.reset') }}</button>
            </div>
          </div>

        </div>
      </div>
    </div>
    </div>

    <div class="row  m-4 mt-0">
      <div class="col-sm-12">
        <div class="row">
          <div class="col-sm-12">
            <div class="card card-body">
              <div class="overflow-auto">
                <table class="table table-bordered align-middle text-left text-nowrap position-relative">
                  <thead>
                  <tr class="bg-light">
                    <th rowspan="2" class="text-capitalize-first">{{ helper.trans('labels.id') }}</th>
                    <th rowspan="2" class="text-capitalize-first">{{ helper.trans('labels.title') }}</th>
                    <th rowspan="2" class="text-capitalize-first">{{ helper.trans('labels.merchant') }}</th>
                    <th colspan="4" class="text-capitalize-first text-center">{{ helper.trans('direction.in') }}</th>
                    <th colspan="4" class="text-capitalize-first text-center">{{ helper.trans('direction.out') }}</th>

                    <th rowspan="2" class="text-end" style="width: 0px">
                    </th>
                  </tr>
                  <tr class="bg-light">
                    <th class="text-capitalize-first" style="width: 0px;"></th>
                    <th class="text-capitalize-first еучу">{{ helper.trans('labels.traffic_group') }}</th>
                    <th class="text-capitalize-first">{{ helper.trans('labels.fee') }}</th>
                    <th class="text-capitalize-first">{{ helper.trans('labels.referral_fee') }}</th>

                    <th class="text-capitalize-first" style="width: 0px;"></th>
                    <th class="text-capitalize-first">{{ helper.trans('labels.traffic_group') }}</th>
                    <th class="text-capitalize-first">{{ helper.trans('labels.fee') }}</th>
                    <th class="text-capitalize-first">{{ helper.trans('labels.referral_fee') }}</th>
                  </tr>
                  </thead>
                  <tbody>
                  <tr v-for="item in response.items" :key="item.id" class="">
                    <td>{{ item.id }}</td>
                    <td>
                      <div>{{ item.name }}</div>
                      <small v-if="!item.isActive" class="text-warning"><i class="fa fa-warning"></i> {{helper.trans('labels.store_not_active')}}</small>

                      <div class="d-flex flex-column">
                        <template v-for="(limit, option) in item.payInRequestLimits">
                          <small v-if="limit < 1" class="text-danger">
                            <i class="fa fa-warning"></i>
                            <span class="ms-1" v-if="option !== 'any'">{{helper.trans(`payment_options.${option}`)}}: </span>
                            {{helper.trans('labels.payInRequestLimitPercentWarning', {percent: numberFormatter.formatNumber(helper.floatToPercent(limit), 0)})}}
                          </small>
                        </template>
                      </div>

                    </td>
                    <td>
                      <UserNameLabel :user="item.merchant"></UserNameLabel>
                    </td>


                    <td>
                      <i v-if="item.isPayInBlocked" class="fa fa-circle-pause text-warning"></i>
                      <i v-else class="fa fa-circle-play text-success"></i>
                    </td>
                    <td>
                      <div v-for="group in item.trafficGroups.filter(gr => gr._trafficGroup?.type === 'in')" :key="group.id">
                        {{group._trafficGroup?.name}}
                      </div>
                    </td>
                    <td>{{numberFormatter.formatNumber(item.payInFee * 100, 2)}}%</td>
                    <td>{{numberFormatter.formatNumber(item.merchant.referralPayInFee * 100 + item.merchant.referral2PayInFee * 100 + item.merchant.referral3PayInFee * 100 + item.merchant.referral4PayInFee * 100 + item.merchant.referral5PayInFee * 100, 2) }}%</td>

                    <td>
                      <i v-if="item.isPayOutBlocked" class="fa fa-circle-pause text-warning"></i>
                      <i v-else class="fa fa-circle-play text-success"></i>
                    </td>
                    <td>
                      <div v-for="group in item.trafficGroups.filter(gr => gr._trafficGroup?.type === 'out')" :key="group.id">
                        {{group._trafficGroup?.name}}
                      </div>
                    </td>
                    <td>{{numberFormatter.formatNumber(item.payOutFee * 100, 2)}}%</td>
                    <td>{{numberFormatter.formatNumber(item.merchant.referralPayOutFee * 100 + item.merchant.referral2PayOutFee * 100 + item.merchant.referral3PayOutFee * 100 + item.merchant.referral4PayOutFee * 100 + item.merchant.referral5PayOutFee * 100, 2) }}%</td>

                    <td class="text-end">
                      <button type="button" @click="showMerchantStoreEditModal(item)" v-b-tooltip.hover :title="helper.trans('button.edit')" class="btn btn-sm btn-outline-dark text-nowrap text-capitalize"><i class="fa fa-pencil"></i></button>
                    </td>
                  </tr>
                  </tbody>
                </table>

                <b-pagination
                  v-if="response.totalCount > response.items.length"
                  v-model="page"
                  :total-rows="response.totalCount"
                  :per-page="response.limit"
                  :limit="20"
                  @update:modelValue="loadList()"
                  prev-text="Back"
                  next-text="Next"
                  align="start"
                  first-number
                  hide-goto-end-buttons
                  hide-ellipsis
                ></b-pagination>

              </div>
            </div>
          </div>

        </div>
      </div>
    </div>

    <b-modal dialog-class="modal-lg"
             :title="merchantStoreModalTitle"
             :modelValue="merchantStoreModal"
             body-class="p-0"
             @update:modelValue="merchantStoreModal = $event"
    >
      <template #default>
        <MerchantStoreForm ref="merchantForm" @open-settings-history="showStoreHistoryFromForm" @open-cross-border-rates="showCrossBorderRates" @open-referral-settings="showReferralFees" @save="saveMerchantStore"></MerchantStoreForm>
      </template>
      <template #footer>
        <button type="button" v-on:click="merchantStoreModal = false" class="btn btn-outline-secondary btn-sm text-capitalize-first">{{ helper.trans('button.cancel') }}</button>
        <LoaderWrapper ref="loaderCreateFrom" :zoom="0.5">
          <button type="button" @click="saveMerchantStore()" class="btn btn-outline-primary btn-sm text-capitalize-first">{{ helper.trans('button.save') }}</button>
        </LoaderWrapper>
      </template>
    </b-modal>

    <SettingsHistoryModal
      ref="storeHistoryModal"
      entity-type="store"
    />

    <CrossBorderRatesModal
      ref="crossBorderRatesModal"
      @apply="applyCrossBorderRates"
    />

    <ReferralStoreFeesModal
      ref="referralFeesModal"
      @apply="applyReferralFees"
    />

  </LoaderWrapper>
</template>
<style scoped>
.no-spinner::-webkit-outer-spin-button,
.no-spinner::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

.no-spinner {
  -moz-appearance: textfield;
  appearance: textfield;
}
</style>
<script lang="ts">
import LoaderWrapper from "@/components/LoaderWrapper.vue";
import {defineComponent, onMounted, reactive, ref, toRefs} from 'vue'
import {dateHelper} from "@/service/DateHelper";
import {numberFormatter} from "@/service/NumberFormatter";
import {api} from "@/service/APIClient";
import {useStore} from "vuex";
import {helper} from "@/service/CommonHelper";
import {useNotification} from "@kyvg/vue3-notification";
import CopyButton from "@/components/CopyButton.vue";
import {BPagination} from "bootstrap-vue-3";
import PaginatedResponseDTO from "@/models/PaginatedResponseDTO";
import MerchantStoreDTO from "@/models/MerchantStoreDTO";
import UserNameLabel from "@/components/UserNameLabel.vue";
import MerchantStoreForm from "@/components/Form/MerchantStoreForm.vue";
import SettingsHistoryModal from "@/components/SettingsHistoryModal.vue";
import CrossBorderRatesModal from "@/components/CrossBorderRatesModal.vue";
import ReferralStoreFeesModal from "@/components/ReferralStoreFeesModal.vue";
import MerchantStoreFormDTO, {CrossBorderSettingRowFormDTO, MerchantStoreTrafficGroupFormDTO, ReferralStoreSettingRowFormDTO} from "@/models/form/MerchantStoreFormDTO";
import PaginationDTO from "@/models/PaginationDTO";
import TrafficGroupDTO from "@/models/TrafficGroupDTO";
import {Dictionary} from "@/types";
import Multiselect from "vue-multiselect";


const notification = useNotification()

export default defineComponent({
  components: {
    Multiselect,
    MerchantStoreForm,
    SettingsHistoryModal,
    CrossBorderRatesModal,
    ReferralStoreFeesModal,
    UserNameLabel,
    LoaderWrapper,
    CopyButton,
    BPagination,
  },
  setup() {
    const store = useStore()
    const loader = ref<InstanceType<typeof LoaderWrapper> | null>(null)
    const loaderCreateFrom = ref<InstanceType<typeof LoaderWrapper> | null>(null)
    const merchantForm = ref<InstanceType<typeof MerchantStoreForm> | null>(null)
    const storeHistoryModal = ref<InstanceType<typeof SettingsHistoryModal> | null>(null)
    const crossBorderRatesModal = ref<InstanceType<typeof CrossBorderRatesModal> | null>(null)
    const referralFeesModal = ref<InstanceType<typeof ReferralStoreFeesModal> | null>(null)

    const state = reactive({
      merchantStoreModal: false,
      merchantStoreModalTitle: "",
      createModal: false,
      page: 1,
      trafficGroupsOptions: [] as TrafficGroupDTO[],
      selectedTrafficGroups: [] as TrafficGroupDTO[],
      storeId: '' as string | number,
      requestDTO: {
        query: '',
        ids: [],
        trafficGroupIds: []
      } as any,
      response: {
        limit: 20,
        offset: 0,
        totalCount: 0,
        items: []
      } as PaginatedResponseDTO<MerchantStoreDTO>
    });

    const loadList = async () => {
      loader.value?.show()
      state.requestDTO.trafficGroupIds = state.selectedTrafficGroups.map((item) => item.id)
      state.requestDTO.ids = state.storeId ? [state.storeId] : []
      state.response.offset = state.response.limit * (state.page - 1)
      state.response = await api.merchantStores(state.response, state.requestDTO)

      let trafficGroupIds = []
      for (const store of state.response.items) {
        for (const item of store.trafficGroups) {
          trafficGroupIds.push(item.id)
        }
      }
      if (trafficGroupIds.length > 0) {
        const trafficGroups = (await api.call.trafficGroups.list({limit: trafficGroupIds.length, offset: 0} as PaginationDTO, {ids: trafficGroupIds})).items
        let trafficGroupsById = {} as Dictionary<TrafficGroupDTO>;
        for (const group of trafficGroups) {
          trafficGroupsById[group.id] = group
        }

        for (const store of state.response.items) {
          for (const item of store.trafficGroups) {
            item._trafficGroup = trafficGroupsById[item.id] ?? null
          }
        }
      }

      loader.value?.hide()
    }

    const showMerchantStoreEditModal = async (dto: MerchantStoreDTO) => {
      let storeDto = dto;
      loader.value?.show();
      try {
        storeDto = await api.storeGet(dto.id);
        const trafficGroupIds = storeDto.trafficGroups.map((item) => item.id);
        if (trafficGroupIds.length > 0) {
          const trafficGroups = (await api.call.trafficGroups.list({limit: trafficGroupIds.length, offset: 0} as PaginationDTO, {ids: trafficGroupIds})).items;
          let trafficGroupsById = {} as Dictionary<TrafficGroupDTO>;
          for (const group of trafficGroups) {
            trafficGroupsById[group.id] = group;
          }
          for (const item of storeDto.trafficGroups) {
            item._trafficGroup = trafficGroupsById[item.id] ?? null;
          }
        }
      } catch (e) {
        notification.notify({
          type: 'error',
          title: helper.trans('labels.error'),
          text: e instanceof Error ? e.message : String(e),
        });
        return;
      } finally {
        loader.value?.hide();
      }

      state.merchantStoreModalTitle = helper.trans('labels.edit_store', {name: storeDto.name})
      let limits = [];
      for (const index in storeDto.payInRequestLimits) {
        limits.push({
          option: index === 'any' ? null : index,
          value: helper.floatToPercent(storeDto.payInRequestLimits[index])
        })
      }

      merchantForm.value?.setForm({
        ...storeDto,
        payInFee: storeDto.payInFee ? (Math.round(storeDto.payInFee * 1000000) / 10000).toString() : null,
        payInFeeByPaymentOption: Object.entries(storeDto.payInFeeByPaymentOption ?? {}).map(([option, fee]) => ({
          option,
          feePercent: helper.floatToPercent(fee).toString()
        })),
        payOutFee: storeDto.payOutFee ? (Math.round(storeDto.payOutFee * 1000000) / 10000).toString() : null,
        minPayInAmount: storeDto.minPayInAmount !== null ? parseInt(storeDto.minPayInAmount).toString() : null,
        maxPayInAmount: storeDto.maxPayInAmount !== null ? parseInt(storeDto.maxPayInAmount).toString() : null,
        minPayOutAmount: storeDto.minPayOutAmount !== null ? parseInt(storeDto.minPayOutAmount).toString() : null,
        maxPayOutAmount: storeDto.maxPayOutAmount !== null ? parseInt(storeDto.maxPayOutAmount).toString() : null,
        trafficGroups: storeDto.trafficGroups.map((item) => {
          return {
            trafficGroup: item._trafficGroup,
            fee: item.fee  ? helper.floatToPercent(item.fee).toString() : null,
            feeByDealAmount: item.feeByDealAmount ? item.feeByDealAmount.map(range => ({
              minSum: range.minSum !== null && range.minSum !== undefined ? (range.minSum / 100).toFixed(2) : null,
              maxSum: range.maxSum !== null && range.maxSum !== undefined ? (range.maxSum / 100).toFixed(2) : null,
              fee: range.fee ? range.fee.toString() : null,
              _feePercent: range.fee ? helper.floatToPercent(range.fee.toString()) : null
            })) : []
          }
        }) as MerchantStoreTrafficGroupFormDTO[],
        isPayInBlocked: storeDto.isPayInBlocked,
        isPayOutBlocked: storeDto.isPayOutBlocked,
        isWebhooksEnabled: storeDto.isWebhooksEnabled,
        isExpiredInvoiceWebhookEnabled: storeDto.isExpiredInvoiceWebhookEnabled ?? false,
        isStrictPayOutDealLifetime: storeDto.isStrictPayOutDealLifetime ?? false,
        dealTimeOutMin: storeDto.dealTimeOutMin,
        payInRequestLimits: limits,
        payInRequestLimitsByAmount: (storeDto.payInRequestLimitsByAmount ?? []).map((range) => ({
          minSum: range.minSum !== null && range.minSum !== undefined ? (Number(range.minSum) / 100).toString() : '',
          maxSum: range.maxSum !== null && range.maxSum !== undefined ? (Number(range.maxSum) / 100).toString() : '',
          value: helper.floatToPercent(range.limit).toString(),
        })),
        disputeOpeningPeriod: storeDto.disputeOpeningPeriod,
        isDisputeReopenAllowed: storeDto.isDisputeReopenAllowed,
        isDisputeAmountChecked: storeDto.isDisputeAmountChecked,
        isDisputeOnCompletedDealsAllowed: storeDto.isDisputeOnCompletedDealsAllowed,
        isDisputeOpeningByApiDisabled: storeDto.isDisputeOpeningByApiDisabled ?? false,
        isAdminOnlyDisputeOnCompleted: storeDto.isAdminOnlyDisputeOnCompleted,
        isAutoDisputeOnExpireEnabled: storeDto.isAutoDisputeOnExpireEnabled ?? false,
        isCancelOnDisputeAutocloseEnabled: storeDto.isCancelOnDisputeAutocloseEnabled ?? false,
        isExpiredOnDealTimeoutEnabled: storeDto.isExpiredOnDealTimeoutEnabled ?? false,
        isUserWhitelistEnabled: storeDto.isUserWhitelistEnabled ?? false,
        userWhitelistText: storeDto.userWhitelist?.length ? JSON.stringify(storeDto.userWhitelist, null, 2) : '',
        isAutoDisputeOnExpireReceiptRequired: storeDto.isAutoDisputeOnExpireReceiptRequired ?? false,
        autoDisputeOnExpirePeriod: storeDto.autoDisputeOnExpirePeriod,
        disputeAutoclosePeriod: storeDto.disputeAutoclosePeriod,
        payOutDealAcceptTimeout: storeDto.payOutDealAcceptTimeout,
        payOutDealDisputeTimeout: storeDto.payOutDealDisputeTimeout,
        payOutDealLifetimeTimeout: storeDto.payOutDealLifetimeTimeout,
        payOutDealSla: storeDto.payOutDealSla ?? '',
        isSingleTakePayOutEnabled: storeDto.isSingleTakePayOutEnabled,
        allowedPaymentOptions: storeDto.allowedPaymentOptions,
        allowedPaymentMethod: storeDto.allowedPaymentMethod,
        blacklistPaymentMethods: storeDto.blacklistPaymentMethods,
        allowedPayoutMethods: storeDto.allowedPayoutMethods,
        isPayoutHolderNameHidden: storeDto.isPayoutHolderNameHidden,
        isOnlySingleConcurrentDealAllowedForUser: storeDto.isOnlySingleConcurrentDealAllowedForUser,
        allowDuplicateInvoices: storeDto.allowDuplicateInvoices,
        nightShiftHours: storeDto.nightShiftHours,
        signatureRequired: storeDto.signatureRequired,
        maxBoundSumForUniqueSums: storeDto.maxBoundSumForUniqueSums.amount,
        payOutFixedRate: storeDto.payOutFixedRateSum?.amount,
        reusablePaymentsCountLimit: storeDto.reusablePaymentsCountLimit === null || storeDto.reusablePaymentsCountLimit === undefined
          ? null
          : storeDto.reusablePaymentsCountLimit.toString(),
        flowType: storeDto.flowType,
        config: storeDto.config,
      } as MerchantStoreFormDTO)
      state.merchantStoreModal = true;
    }

    const saveMerchantStore = () => {
      loaderCreateFrom.value?.show()

      merchantForm.value?.save()
        ?.then(async (resp) => {
          state.merchantStoreModal = false;
          loadList();
        })
        .catch((e) => {
          if (e?.response?.status === 400 && e?.response?.data) {
            merchantForm.value?.handleSaveErrors(e.response.data);
          }
        })
        .finally(() => {
          loaderCreateFrom.value?.hide();
        })
    }

    const applyFilters = async () => {
      state.page = 1;
      loadList()
    }

    const clearFilters = async () => {
      state.page = 1;
      state.requestDTO = {
        query: '',
        ids: [],
        trafficGroupIds: []
      }
      state.storeId = ''
      state.selectedTrafficGroups = []
      loadList()
    }

    const showCrossBorderRates = () => {
      const form = merchantForm.value?.getForm()
      crossBorderRatesModal.value?.show(
        form?.crossBorderSettings ?? [],
        merchantForm.value?.getCrossBorderErrors() ?? [],
        form?.id ?? null,
        form?.name ?? '',
      )
    }

    const applyCrossBorderRates = (rows: CrossBorderSettingRowFormDTO[]) => {
      merchantForm.value?.setCrossBorderSettings(rows)
    }

    const showReferralFees = () => {
      const form = merchantForm.value?.getForm()
      referralFeesModal.value?.show(
        form?.referralSettings ?? [],
        merchantForm.value?.getReferralErrors() ?? [],
      )
    }

    const applyReferralFees = (rows: ReferralStoreSettingRowFormDTO[]) => {
      merchantForm.value?.setReferralSettings(rows)
    }

    const showStoreHistoryFromForm = () => {
      const form = merchantForm.value?.getForm()
      if (!form?.id) {
        return
      }

      storeHistoryModal.value?.show(
        form.id,
        helper.trans('labels.settings_history') + `: ${form.name}`,
      )
    }

    onMounted(async () => {
      state.trafficGroupsOptions = await api.call.trafficGroups.all()
      loadList()
    });

    return {
      ...toRefs(state),
      showMerchantStoreEditModal,
      store,
      loader,
      dateHelper,
      numberFormatter,
      helper,
      loadList,
      loaderCreateFrom,
      saveMerchantStore,
      applyFilters,
      clearFilters,
      merchantForm,
      showStoreHistoryFromForm,
      storeHistoryModal,
      showCrossBorderRates,
      applyCrossBorderRates,
      crossBorderRatesModal,
      showReferralFees,
      applyReferralFees,
      referralFeesModal,
    }
  }
})
</script>
